import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDeviceData } from 'cet-components-lib/dist/hooks';

export const useSideBar = () => {
  const { isMobile, isMobileView } = useDeviceData();
  const intl = useIntl();
  const { pathname } = useLocation();
  const messagesLength = Object.keys(intl.messages).length;
  const navigate = useNavigate();

  const handleClick = ( e, url ) => {
    e.preventDefault();
    navigate(`/${intl.locale}/${url}`);
  }

  const getSideBarItems = useCallback(() => {
    const isIvritIL = intl.locale === 'ivritil';
    
    // IvritIL Activities sub-menu items
    const activitiesSubItems = [
      {
        id: 'activities-bishvil-haivrit',
        onClick: (e) => handleClick(e, 'activities/bishvil-haivrit'),
        label: 'בשביל העברית',
        isSelected: pathname.includes('/activities/bishvil-haivrit')
      },
      {
        id: 'activities-yesh-veyesh',
        onClick: (e) => handleClick(e, 'activities/yesh-veyesh'),
        label: 'יש ויש',
        isSelected: pathname.includes('/activities/yesh-veyesh')
      },
      {
        id: 'activities-ivrit-beklick',
        onClick: (e) => handleClick(e, 'activities/ivrit-beklick'),
        label: 'עברית בקליק',
        isSelected: pathname.includes('/activities/ivrit-beklick')
      },
      {
        id: 'activities-mechina',
        onClick: (e) => handleClick(e, 'activities/mechina'),
        label: 'מכינה',
        isSelected: pathname.includes('/activities/mechina')
      },
      {
        id: 'activities-ivrit-advance',
        onClick: (e) => handleClick(e, 'activities/ivrit-advance'),
        label: 'עברית למתקדמים',
        isSelected: pathname.includes('/activities/ivrit-advance')
      },
      {
        id: 'activities-besod-haivrit',
        onClick: (e) => handleClick(e, 'activities/besod-haivrit'),
        label: 'בסוד העברית',
        isSelected: pathname.includes('/activities/besod-haivrit')
      },
      {
        id: 'activities-paalolan',
        onClick: (e) => {
          e.preventDefault();
          window.open('https://hebrewverbs.cet.ac.il', '_blank', 'noopener,noreferrer');
        },
        label: 'פעלולן',
        isSelected: false
      }
    ];
    
    const catalogItem = {
      id: 'catalog',
      onClick:  (e) => handleClick(e,'catalog'),
      icon: "Flower",
      label: intl.formatMessage({ id: 'catalog' }),
      isSelected: pathname === `/${intl.locale}/catalog`
    };

    const toReturn = [
      {
        id: 'activities',
        onClick:  (e) => handleClick(e,''),
        icon: "Activities",
        label: intl.formatMessage({ id: 'tasks_status_student' }),
        isSelected: pathname === `/${intl.locale}`
      },
      // Show catalog here only when NOT in IvritIL mode
      ...(!isIvritIL ? [catalogItem] : []),
      // Show ivritil-activities only when in IvritIL mode
      ...(isIvritIL ? [{
        id: 'ivritil-activities',
        onClick:  (e) => handleClick(e,'activities'),
        icon: "Flower",
        label: 'Activities',
        isSelected: pathname.includes(`/${intl.locale}/activities`),
        isMoreMenuItemOpen: false,
        items: activitiesSubItems
      }] : []),
      {
        id: 'books',
        onClick:  (e) => handleClick(e,'books'),
        icon: "Book",
        label: intl.formatMessage({ id: 'books' }),
        isSelected: pathname === `/${intl.locale}/books`
      },
      {
        id: 'courses',
        onClick:  (e) => handleClick(e,'courses'),
        icon: "Courses",
        label: intl.formatMessage({ id: 'courses' }),
        isSelected: pathname === `/${intl.locale}/courses`
      },
      // Show catalog last when in IvritIL mode
      ...(isIvritIL ? [catalogItem] : []),
    ];
    if (!isMobileView && !isMobile && !isIvritIL) {
      toReturn.push({
        id: 'tools',
        onClick:  (e) => handleClick(e,'tools'),
        icon: "Studio",
        label: intl.formatMessage({ id: 'tools_title_students' }),
        isSelected: pathname === `/${intl.locale}/tools`
      });
    }
    return toReturn;
  },[intl, isMobile, isMobileView, pathname]);

  const sideBarItems = useMemo(
    () => (messagesLength > 0
      ? getSideBarItems()
      : []
    ),
    [messagesLength, getSideBarItems]
  );

  return sideBarItems;
};
